<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="pid" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.上级id')}}<template slot="title">{{$t('商品评价.上级id')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.pid"  :placeholder="$t('通用.输入.请输入')+$t('商品评价.上级id')" />
      </a-form-model-item>
      <a-form-model-item prop="orderId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.订单ID')}}<template slot="title">{{$t('商品评价.订单ID')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.orderId"  :placeholder="$t('通用.输入.请输入')+$t('商品评价.订单ID')" />
      </a-form-model-item>
      <a-form-model-item prop="orderNo" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.订单编号')}}<template slot="title">{{$t('商品评价.订单编号')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.orderNo"  :placeholder="$t('通用.输入.请输入')+$t('商品评价.订单编号')" />
      </a-form-model-item>
      <a-form-model-item prop="orderGoodsId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.订单项ID')}}<template slot="title">{{$t('商品评价.订单项ID')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.orderGoodsId"  :placeholder="$t('通用.输入.请输入')+$t('商品评价.订单项ID')" />
      </a-form-model-item>
      <a-form-model-item prop="goodsId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.商品ID')}}<template slot="title">{{$t('商品评价.商品ID')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.goodsId"  :placeholder="$t('通用.输入.请输入')+$t('商品评价.商品ID')" />
      </a-form-model-item>
      <a-form-model-item prop="goodsCode" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.商品编号')}}<template slot="title">{{$t('商品评价.商品编号')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.goodsCode" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('商品评价.商品编号')" />
      </a-form-model-item>
      <a-form-model-item prop="goodsName" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.商品名称')}}<template slot="title">{{$t('商品评价.商品名称')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.goodsName" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('商品评价.商品名称')" />
      </a-form-model-item>
      <a-form-model-item prop="goodsPrice" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.商品价格')}}<template slot="title">{{$t('商品评价.商品价格')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.goodsPrice"  :placeholder="$t('通用.输入.请输入')+$t('商品评价.商品价格')" />
      </a-form-model-item>
      <a-form-model-item prop="goodsImage" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.商品图片')}}<template slot="title">{{$t('商品评价.商品图片')}}</template>
          </a-tooltip>
        </span>
        <file-upload v-model="form.goodsImage" type="image"></file-upload>
      </a-form-model-item>
      <a-form-model-item prop="skuName" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.规格名称')}}<template slot="title">{{$t('商品评价.规格名称')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.skuName" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('商品评价.规格名称')" />
      </a-form-model-item>
      <a-form-model-item prop="shopId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.店铺ID')}}<template slot="title">{{$t('商品评价.店铺ID')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.shopId"  :placeholder="$t('通用.输入.请输入')+$t('商品评价.店铺ID')" />
      </a-form-model-item>
      <a-form-model-item prop="shopName" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.店铺名称')}}<template slot="title">{{$t('商品评价.店铺名称')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.shopName" :maxLength="100" :placeholder="$t('通用.输入.请输入')+$t('商品评价.店铺名称')" />
      </a-form-model-item>
      <a-form-model-item prop="goodsType" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.是否自营  0：否 1：是')}}<template slot="title">{{$t('商品评价.是否自营  0：否 1：是')}}</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="content" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.评价内容')}}<template slot="title">{{$t('商品评价.评价内容')}}</template>
          </a-tooltip>
        </span>
        <editor v-model="form.content" />
      </a-form-model-item>
      <a-form-model-item prop="image" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.评价图片')}}<template slot="title">{{$t('商品评价.评价图片')}}</template>
          </a-tooltip>
        </span>
        <file-upload v-model="form.image" type="image"></file-upload>
      </a-form-model-item>
      <a-form-model-item prop="explainFirst" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.解释内容')}}<template slot="title">{{$t('商品评价.解释内容')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.explainFirst" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('商品评价.解释内容')" />
      </a-form-model-item>
      <a-form-model-item prop="memberName" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.评价人名称')}}<template slot="title">{{$t('商品评价.评价人名称')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.memberName" :maxLength="100" :placeholder="$t('通用.输入.请输入')+$t('商品评价.评价人名称')" />
      </a-form-model-item>
      <a-form-model-item prop="number" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.点赞数量')}}<template slot="title">{{$t('商品评价.点赞数量')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.number"  :placeholder="$t('通用.输入.请输入')+$t('商品评价.点赞数量')" />
      </a-form-model-item>
      <a-form-model-item prop="userId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.评价人编号')}}<template slot="title">{{$t('商品评价.评价人编号')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.userId"  :placeholder="$t('通用.输入.请输入')+$t('商品评价.评价人编号')" />
      </a-form-model-item>
      <a-form-model-item prop="avatar" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.头像')}}<template slot="title">{{$t('商品评价.头像')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.avatar" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('商品评价.头像')" />
      </a-form-model-item>
      <a-form-model-item prop="isAnonymous" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.0表示不是 1表示是匿名评价')}}<template slot="title">{{$t('商品评价.0表示不是 1表示是匿名评价')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.isAnonymous"  :placeholder="$t('通用.输入.请输入')+$t('商品评价.0表示不是 1表示是匿名评价')" />
      </a-form-model-item>
      <a-form-model-item prop="evaluateScores" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.评价星级')}}<template slot="title">{{$t('商品评价.评价星级')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.evaluateScores"  :placeholder="$t('通用.输入.请输入')+$t('商品评价.评价星级')" />
      </a-form-model-item>
      <a-form-model-item prop="qualityScores" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.物流服务')}}<template slot="title">{{$t('商品评价.物流服务')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.qualityScores"  :placeholder="$t('通用.输入.请输入')+$t('商品评价.物流服务')" />
      </a-form-model-item>
      <a-form-model-item prop="serviceScores" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.服务评分')}}<template slot="title">{{$t('商品评价.服务评分')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.serviceScores"  :placeholder="$t('通用.输入.请输入')+$t('商品评价.服务评分')" />
      </a-form-model-item>
      <a-form-model-item prop="againContent" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.追加评价内容')}}<template slot="title">{{$t('商品评价.追加评价内容')}}</template>
          </a-tooltip>
        </span>
        <editor v-model="form.againContent" />
      </a-form-model-item>
      <a-form-model-item prop="againImage" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.追加评价图片')}}<template slot="title">{{$t('商品评价.追加评价图片')}}</template>
          </a-tooltip>
        </span>
        <file-upload v-model="form.againImage" type="image"></file-upload>
      </a-form-model-item>
      <a-form-model-item prop="againExplain" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.追加解释内容')}}<template slot="title">{{$t('商品评价.追加解释内容')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.againExplain" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('商品评价.追加解释内容')" />
      </a-form-model-item>
      <a-form-model-item prop="explainType" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.1好评2中评3差评')}}<template slot="title">{{$t('商品评价.1好评2中评3差评')}}</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="isShow" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.1显示 0隐藏')}}<template slot="title">{{$t('商品评价.1显示 0隐藏')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.isShow"  :placeholder="$t('通用.输入.请输入')+$t('商品评价.1显示 0隐藏')" />
      </a-form-model-item>
      <a-form-model-item prop="againAddtime" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.追加评价时间')}}<template slot="title">{{$t('商品评价.追加评价时间')}}</template>
          </a-tooltip>
        </span>
        <a-date-picker style="width: 100%" v-model="form.againAddtime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="videoUrl" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.评价视频')}}<template slot="title">{{$t('商品评价.评价视频')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.videoUrl" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('商品评价.评价视频')" />
      </a-form-model-item>
      <a-form-model-item prop="type" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.评价类型.0:文字；1:图片；2:视频')}}<template slot="title">{{$t('商品评价.评价类型.0:文字；1:图片；2:视频')}}</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="coverImage" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.视频封面图')}}<template slot="title">{{$t('商品评价.视频封面图')}}</template>
          </a-tooltip>
        </span>
        <file-upload v-model="form.coverImage" type="image"></file-upload>
      </a-form-model-item>
      <a-form-model-item prop="faceTo" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.评价面向：0商品，1店铺')}}
            <template slot="title">{{$t('商品评价.评价面向：0商品，1店铺')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.faceTo"  :placeholder="$t('通用.输入.请输入')+$t('商品评价.评价面向：0商品，1店铺')" />
      </a-form-model-item>
      <a-form-model-item prop="pushTop" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.置顶：0、未置顶   1、置顶')}}
            <template slot="title">{{$t('商品评价.置顶：0、未置顶   1、置顶')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.pushTop"  :placeholder="$t('通用.输入.请输入')+$t('商品评价.置顶：0、未置顶   1、置顶')" />
      </a-form-model-item>
      <a-form-model-item prop="inventEvaluate" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.是否虚拟评价：0、普通用户   1、虚拟用户')}}<template slot="title">{{$t('商品评价.是否虚拟评价：0、普通用户   1、虚拟用户')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.inventEvaluate"  :placeholder="$t('通用.输入.请输入')+$t('商品评价.是否虚拟评价：0、普通用户   1、虚拟用户')" />
      </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品评价.备注')}}<template slot="title">{{$t('商品评价.备注')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getEvaluate, addEvaluate, updateEvaluate } from '@/api/goods/evaluate'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";

import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
    Editor
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,

        pid: null,

        orderId: null,

        orderNo: null,

        orderGoodsId: null,

        goodsId: null,

        goodsCode: null,

        goodsName: null,

        goodsPrice: null,

        goodsImage: null,

        skuName: null,

        shopId: null,

        shopName: null,

        goodsType: null,

        content: null,

        image: null,

        explainFirst: null,

        memberName: null,

        number: null,

        userId: null,

        avatar: null,

        isAnonymous: null,

        evaluateScores: null,

        qualityScores: null,

        serviceScores: null,

        againContent: null,

        againImage: null,

        againExplain: null,

        explainType: null,

        isShow: null,

        againAddtime: null,

        videoUrl: null,

        type: null,

        coverImage: null,

        faceTo: null,

        pushTop: null,

        inventEvaluate: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        orderId: [
          { required: true, message: this.$t('商品评价.订单ID')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        orderNo: [
          { required: true, message: this.$t('商品评价.订单编号')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        orderGoodsId: [
          { required: true, message: this.$t('商品评价.订单项ID')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        goodsId: [
          { required: true, message: this.$t('商品评价.商品ID')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        goodsCode: [
          { required: true, message: this.$t('商品评价.商品编号')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        goodsName: [
          { required: true, message: this.$t('商品评价.商品名称')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        goodsPrice: [
          { required: true, message: this.$t('商品评价.商品价格')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        goodsImage: [
          { required: true, message: this.$t('商品评价.商品图片')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        shopId: [
          { required: true, message: this.$t('商品评价.店铺ID')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        shopName: [
          { required: true, message: this.$t('商品评价.店铺名称')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        content: [
          { required: true, message: this.$t('商品评价.评价内容')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        image: [
          { required: true, message: this.$t('商品评价.评价图片')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        memberName: [
          { required: true, message: this.$t('商品评价.评价人名称')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        userId: [
          { required: true, message: this.$t('商品评价.评价人编号')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        isAnonymous: [
          { required: true, message: this.$t('商品评价.0表示不是 1表示是匿名评价')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        evaluateScores: [
          { required: true, message: this.$t('商品评价.评价星级')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        qualityScores: [
          { required: true, message: this.$t('商品评价.物流服务')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        serviceScores: [
          { required: true, message: this.$t('商品评价.服务评分')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        pid: null,
        orderId: null,
        orderNo: null,
        orderGoodsId: null,
        goodsId: null,
        goodsCode: null,
        goodsName: null,
        goodsPrice: null,
        goodsImage: null,
        skuName: null,
        shopId: null,
        shopName: null,
        goodsType: null,
        content: null,
        image: null,
        explainFirst: null,
        memberName: null,
        number: null,
        userId: null,
        avatar: null,
        isAnonymous: null,
        evaluateScores: null,
        qualityScores: null,
        serviceScores: null,
        againContent: null,
        againImage: null,
        againExplain: null,
        explainType: null,
        isShow: null,
        againAddtime: null,
        videoUrl: null,
        type: null,
        coverImage: null,
        faceTo: null,
        pushTop: null,
        inventEvaluate: null,
        createTime: null,
        remark: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getEvaluate({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateEvaluate(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addEvaluate(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
